document.addEventListener('change', (event) => {
  const pack = event.target.closest('[data-nagomi-pack] input[name="nagomi-pack"]');
  if (!pack) return;
  const productInfo = pack.closest('product-info');
  const quantity = productInfo?.querySelector('input[name="quantity"]');
  if (!quantity) return;
  quantity.value = pack.value;
  quantity.dispatchEvent(new Event('change', { bubbles: true }));
});

const setupNagomiMobileBuy = () => {
  document.querySelectorAll('product-info').forEach((productInfo) => {
    const bar = productInfo.querySelector('[data-nagomi-mobile-buy]');
    const mobileButton = productInfo.querySelector('[data-nagomi-mobile-submit]');
    const mobilePrice = productInfo.querySelector('[data-nagomi-mobile-price]');
    const mainButton = productInfo.querySelector('.product-form__submit');
    const price = productInfo.querySelector('[id^="price-"]');
    if (!bar || !mobileButton || !mainButton || !price) return;

    const sync = () => {
      const currentPrice = price.querySelector('.price-item--sale, .price-item--regular');
      const nextPrice = currentPrice?.textContent?.trim();
      if (nextPrice && mobilePrice && mobilePrice.textContent.trim() !== nextPrice) mobilePrice.textContent = nextPrice;
      const nextDisabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      if (mobileButton.disabled !== nextDisabled) mobileButton.disabled = nextDisabled;
      const label = mainButton.querySelector('span')?.textContent?.trim();
      if (label && mobileButton.textContent.trim() !== label) mobileButton.textContent = label;
      if (bar.hidden) bar.hidden = false;
    };

    mobileButton.addEventListener('click', () => mainButton.click());
    new MutationObserver(sync).observe(price, { subtree: true, childList: true, characterData: true });
    new MutationObserver(sync).observe(mainButton, { subtree: true, childList: true, attributes: true });
    sync();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupNagomiMobileBuy, { once: true });
} else {
  setupNagomiMobileBuy();
}

document.addEventListener('click', (event) => {
  const finalCta = event.target.closest('[data-nagomi-final-cta]');
  if (!finalCta) return;
  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;
  event.preventDefault();
  productInfo.scrollIntoView({ behavior: 'smooth', block: 'start' });
  window.setTimeout(() => productInfo.querySelector('input:not([disabled]), button:not([disabled])')?.focus({ preventScroll: true }), 550);
});
